import { fullNameFromEmail } from '../taActionBoard/format';

/**
 * "lena.weber@finn.com" → "Lena Weber", with the links views' empty sentinel.
 * Delegates to the action board's transform so a naming fix (de Vries, O'Brien)
 * lands once and both surfaces keep naming the same person the same way.
 */
export const personLabel = (email?: string | null) =>
  email ? fullNameFromEmail(email) : 'Unassigned';
